module.exports = __webpack_public_path__ + "static/media/home-epay-img1.fe561060.svg";